import React from "react";
import styled from "styled-components";
import { useTrainingStore } from "../../stores/trainingStore";
import { formatTime } from "../../utils/formatTime";

// --- Styled Components ---

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  background: var(--card-bg);
  padding: 20px;
  border-radius: 24px;
  margin-top: auto; /* 화면 하단에 배치 */
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 20%;
    height: 60%;
    width: 1px;
    background: rgba(255, 255, 255, 0.1);
  }
`;

const Value = styled.span`
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--text-main);
  font-variant-numeric: tabular-nums;
`;

const Label = styled.span`
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--text-sub);
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

// --- Component ---

export const StatsPanel: React.FC = () => {
  const { totalDistance, elapsedSeconds } = useTrainingStore();

  // 미터를 킬로미터로 변환 (소수점 2자리)
  const distanceKm = (totalDistance / 1000).toFixed(2);

  // 페이스 계산 (1km당 걸리는 시간)
  const paceSeconds =
    totalDistance > 0 ? Math.round((elapsedSeconds / totalDistance) * 1000) : 0;

  return (
    <StatsContainer>
      <StatItem>
        <Value>{distanceKm}</Value>
        <Label>Kilometers</Label>
      </StatItem>

      <StatItem>
        <Value>{formatTime(elapsedSeconds)}</Value>
        <Label>Total Time</Label>
      </StatItem>

      <StatItem>
        <Value>{paceSeconds > 0 ? formatTime(paceSeconds) : "--:--"}</Value>
        <Label>Avg Pace</Label>
      </StatItem>
    </StatsContainer>
  );
};
